import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const uiStateDefaultVariants = {
  "variant": "empty"
}
const uiStateCompoundVariants = []

const uiStateSlotNames = [
  [
    "root",
    "UiState__root"
  ],
  [
    "content",
    "UiState__content"
  ],
  [
    "title",
    "UiState__title"
  ],
  [
    "description",
    "UiState__description"
  ]
]
const uiStateSlotFns = /* @__PURE__ */ uiStateSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, uiStateDefaultVariants, getSlotCompoundVariant(uiStateCompoundVariants, slotName))])

const uiStateFn = memo((props = {}) => {
  return Object.fromEntries(uiStateSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const uiStateVariantKeys = [
  "variant"
]
const getVariantProps = (variants) => ({ ...uiStateDefaultVariants, ...compact(variants) })

export const uiState = /* @__PURE__ */ Object.assign(uiStateFn, {
  __recipe__: false,
  __name__: 'uiState',
  raw: (props) => props,
  variantKeys: uiStateVariantKeys,
  variantMap: {
  "variant": [
    "empty",
    "success",
    "error",
    "loading"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, uiStateVariantKeys)
  },
  getVariantProps
})